import QuestionmarkDiamond from './QuestionmarkDiamond';

export default QuestionmarkDiamond;
